import { getCurrentEnv } from './browserContext';

export enum ENVIRONMENT {
    DEVELOPMENT = 'development',
    PRODUCTION = 'production',
}

const BRAZE_API_KEYS: Record<ENVIRONMENT, string> = {
    [ENVIRONMENT.DEVELOPMENT]: '6efef382-258b-42d7-beae-ab4c69233b14',
    [ENVIRONMENT.PRODUCTION]: 'c13ad1be-26c8-421e-9f3c-1a1a1df47452',
};

export const CURRENT_ENV = getCurrentEnv();

export const BRAZE_API_KEY = BRAZE_API_KEYS[CURRENT_ENV];
export const BRAZE_BASE_URL = 'sdk.iad-06.braze.com';
